export const config = {
  confetti: {
    alpha: {
      start: 0.5,
      end: 1,
    },
    scale: {
      start: 0.01,
      end: 0.15,
      minimumScaleMultiplier: 25,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 500,
      end: 200,
      minimumSpeedMultiplier: 2,
    },
    acceleration: {
      x: 5,
      y: 600,
    },
    maxSpeed: 0,
    startRotation: {
      min: 300,
      max: -360,
    },
    noRotation: false,
    rotationSpeed: {
      min: 4,
      max: 500,
    },
    lifetime: {
      min: 3,
      max: 4,
    },
    blendMode: 'luminosity',
    frequency: 0.004,
    emitterLifetime: -1,
    maxParticles: 5000,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: 'point',
  },
}
